document.addEventListener('DOMContentLoaded', () => {
  setupToggleColumn();
  setupToggleDrawing();
  setupVATSwitches();
  setupAlertButton();
  updateLayout();

  if (window.innerWidth > 768) {
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateLayout, 100);
    });
  };

  if (window.innerWidth < 768) {
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(syncAllRowHeights, 100);
    });
  };

});

function updateLayout() {
  duplicateFirstColumn();
  syncAllRowHeights();
  alignSwitchContainer();
}

function alignSwitchContainer () {
  if (document.querySelector('.drawing-container')) {
    const element = document.querySelector('.switch-container.by-table');
    if (element) {
      element.classList.add('drawing-visible');
    }
  }
}

function syncAllRowHeights() {
  const leftAllRows = document.querySelectorAll('.quick-order-list__table tr');
  const rightAllRows = document.querySelectorAll('.specification-table tr');
  const stickyAllRows = document.querySelectorAll('.sticky-column .sticky-cell');

  const leftVisibleRows = Array.from(leftAllRows).filter(row => row.offsetParent !== null);
  const rightVisibleRows = Array.from(rightAllRows).filter(row => row.offsetParent !== null);
  const stickyVisibleRows = Array.from(stickyAllRows).filter(row => row.offsetParent !== null);

  [...leftAllRows, ...rightAllRows, ...stickyAllRows].forEach(row => row.style.height = '');

  let rowCount;
  if (stickyVisibleRows.length > 0) {
    rowCount = Math.min(leftVisibleRows.length, rightVisibleRows.length, stickyVisibleRows.length);
  } else {
    rowCount = Math.min(leftVisibleRows.length, rightVisibleRows.length);
  }

  for (let i = 0; i < rowCount; i++) {
    const leftRow = leftVisibleRows[i];
    const rightRow = rightVisibleRows[i];
    const stickyRow = stickyVisibleRows[i]; 

    const leftHeight = leftRow.getBoundingClientRect().height;
    const rightHeight = rightRow.getBoundingClientRect().height;
    const stickyHeight = stickyRow?.getBoundingClientRect().height || 0;

    const maxHeight = Math.ceil(Math.max(leftHeight, rightHeight, stickyHeight));

    leftRow.style.height = `${maxHeight}px`;
    rightRow.style.height = `${maxHeight}px`;
    if (stickyRow) stickyRow.style.height = `${maxHeight}px`;
  }
}

function runSyncUntilStable(attemptsLeft = 75) {
  syncAllRowHeights();
  if (attemptsLeft <= 0) return;
  setTimeout(() => runSyncUntilStable(attemptsLeft - 1), 100);
}

window.addEventListener('load', () => {
  runSyncUntilStable();
});

window.addEventListener('resize', syncAllRowHeights);

function duplicateFirstColumn() {
  const existingSticky = document.querySelector(".sticky-column");
  if (existingSticky) {
    existingSticky.remove();
    document.querySelectorAll("td.variant-item__inner .title-container").forEach(el => {
      el.style.visibility = "visible";
    });
  }

  if (window.innerWidth < 990) {
    const targetTable = document.querySelector(".quick-order-list__table");
    if (!targetTable) return;

    const titles = document.querySelectorAll("td.variant-item__inner .title-container");
    if (!titles.length) return;

    const stickyColumn = document.createElement("div");
    stickyColumn.className = "sticky-column";

    const leftRows = Array.from(document.querySelectorAll(".quick-order-list__table tr"));
    const visibleLeftRows = leftRows.filter(row => row.offsetParent !== null);

    const firstRow = visibleLeftRows[0];
    const headerSpacer = document.createElement("div");
    headerSpacer.className = "sticky-cell empty-cell";
    if (firstRow) {
      headerSpacer.style.height = `${firstRow.offsetHeight}px`;
    }
    stickyColumn.appendChild(headerSpacer);

    let rowIndex = 1; 
    titles.forEach((titleEl) => {
      if (titleEl.offsetParent === null) return;

      const clone = titleEl.cloneNode(true);
      const wrapper = document.createElement("div");
      wrapper.className = "sticky-cell";

      const correspondingRow = visibleLeftRows[rowIndex++];
      if (correspondingRow) {
        wrapper.style.height = `${correspondingRow.offsetHeight}px`;
      }

      wrapper.appendChild(clone);
      stickyColumn.appendChild(wrapper);
      titleEl.style.visibility = "hidden";
    });

    targetTable.parentNode.insertBefore(stickyColumn, targetTable);
    syncAllRowHeights(); 
  }
}

function setupAlertButton() {
  document.querySelectorAll('.alert_btn').forEach(button => {
    button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        window.scrollTo({ top: 0, behavior: 'smooth' });

        const dataValue = this.getAttribute('data-value');
        const values = dataValue.split(' / ');

        const firstDropdown = document.querySelector('.product-form-input .select__select');
        const secondDropdown = document.querySelectorAll('.product-form-input .select__select')[1];
        const thirdDropdown = document.querySelectorAll('.product-form-input .select__select')[2];

        if (firstDropdown && values[0]) {
            setTimeout(() => {
                const firstOption = firstDropdown.querySelector(`option[value="${values[0]}"]`);
                if (firstOption) {
                    firstDropdown.value = values[0];
                    const event = new Event('change', { bubbles: true });
                    firstDropdown.dispatchEvent(event);
                }
            }, 500);
        }

        if (secondDropdown && values[1]) {
            setTimeout(() => {
                const secondOption = secondDropdown.querySelector(`option[value="${values[1]}"]`);
                if (secondOption) {
                    secondDropdown.value = values[1];
                    const event = new Event('change', { bubbles: true });
                    secondDropdown.dispatchEvent(event);
                }
            }, 500);
        }

        if (thirdDropdown && values[2]) {
            setTimeout(() => {
                const thirdOption = thirdDropdown.querySelector(`option[value="${values[2]}"]`);
                if (thirdOption) {
                    thirdDropdown.value = values[2];
                    const event = new Event('change', { bubbles: true });
                    thirdDropdown.dispatchEvent(event);
                }
            }, 500);
        }

        const waitForEmailButton = setInterval(() => {
            const emailButton = document.querySelector('.email-me-button');
            if (emailButton) {
                clearInterval(waitForEmailButton);
                emailButton.click();
            }
        }, 500);
    });
});
}

function setupToggleColumn() {
  const specSwitch = document.querySelector('.spec-switch');
  const toggleColumn = document.getElementById('toggleColumn');
  
  if (!specSwitch || !toggleColumn) return;

  specSwitch.addEventListener('click', () => {
    toggleColumn.checked = !toggleColumn.checked;
    toggleColumn.dispatchEvent(new Event('change'));
  });

  toggleColumn.addEventListener('change', ({ target }) => {
    document.querySelectorAll('.toggle-col').forEach(col => 
      col.classList.toggle('hidden', !target.checked)
    );
  });
}

function setupToggleDrawing() {
  const drawingSwitch = document.querySelector('.drawing-switch');
  const toggleDrawing = document.getElementById('toggleDrawing');
  
  if (!drawingSwitch || !toggleDrawing) return;

  drawingSwitch.addEventListener('click', () => {
    toggleDrawing.checked = !toggleDrawing.checked;
    toggleDrawing.dispatchEvent(new Event('change'));
  });

  toggleDrawing.addEventListener('change', ({ target }) => {
    document.querySelector('.drawing-container').classList.toggle('hidden', !target.checked);
    document.querySelector('quick-order-list').classList.toggle('show-drawing', target.checked);
  });
}


function setupVATSwitches() {
  const toggleVATs = document.querySelectorAll('.toggleVAT');
  if (!toggleVATs.length) return;

  const VATstate = localStorage.getItem('VATtoggle') === 'true';
  updateVATState(VATstate);

  toggleVATs.forEach(toggle => {
    toggle.checked = VATstate;
    toggle.addEventListener('change', ({ target }) => {
      updateVATState(target.checked);
      toggleVATs.forEach(switchElement => {
        switchElement.checked = target.checked;
      });
    });
  });
}

function updateVATState(state) {
  document.body.classList.toggle('ex-vat', state);
  document.body.classList.toggle('inc-vat', !state);
  localStorage.setItem('VATtoggle', state);
}

document.addEventListener("DOMContentLoaded", function() {
  if (window.innerWidth > 989 && !('ontouchstart' in window)) {
    const zoomContainer = document.querySelector(".zoom-container");
  
    if (zoomContainer) {
      zoomContainer.addEventListener("mousemove", function(event) {
        let { offsetX, offsetY } = event;
        let { offsetWidth, offsetHeight } = zoomContainer;
    
        let moveX = (offsetX / offsetWidth) * 100;
        let moveY = (offsetY / offsetHeight) * 100;
    
        zoomContainer.style.backgroundPosition = `${moveX}% ${moveY}%`;
      });
      
      zoomContainer.addEventListener("mouseleave", function() {
        zoomContainer.style.backgroundPosition = "center";
      });
    };
    
    function applyZoomEffect(imageContainer) {
      const img = imageContainer.querySelector("img");
  
      imageContainer.addEventListener("mousemove", function (event) {
        const { left, top, width, height } = imageContainer.getBoundingClientRect();
        const x = ((event.clientX - left) / width) * 100;
        const y = ((event.clientY - top) / height) * 100;
        
        img.style.transformOrigin = `${x}% ${y}%`;
        img.style.transform = "scale(2)"; // Adjust zoom level
      });
  
      imageContainer.addEventListener("mouseleave", function () {
        img.style.transform = "scale(1)";
        img.style.transformOrigin = "center";
      });
    }
  
    document.querySelectorAll(".product-image-container").forEach(applyZoomEffect);
  
    const observer = new MutationObserver(() => {
      document.querySelectorAll(".product-image-container").forEach(applyZoomEffect);
    });
  
    const productMedia = document.querySelector(".product__media") || document.body;
    observer.observe(productMedia, { childList: true, subtree: true });
    };
  
    const scrollLink = document.querySelector('.scroll-cue-right');

    if (scrollLink) {
      scrollLink.addEventListener('click', function(e) {
        e.preventDefault();

        const target = document.querySelector('#quick-order-list');
        if (!target) return;

        const headerOffset = 320; 
        const elementPosition = target.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      });
    }

    const container = document.querySelector('.quick-order-list__container');
    const prompt = document.querySelector('.scroll-cue-right.table-cue');
    const toggleColumn = document.getElementById('toggleColumn');

    function updateScrollPrompt() {
      const hasOverflow = container.scrollWidth > container.clientWidth;
      prompt.style.display = hasOverflow ? 'block' : 'none';
    }

    updateScrollPrompt();
    window.addEventListener('resize', updateScrollPrompt);

    container.addEventListener('scroll', () => {
      const atRight =
        container.scrollLeft + container.clientWidth >= container.scrollWidth - 1;
      prompt.style.display = atRight ? 'none' : 'block';
    });

    if (toggleColumn) {
      toggleColumn.addEventListener('change', () => {
        requestAnimationFrame(updateScrollPrompt);
        setTimeout(updateScrollPrompt, 10); 
      });
    }
});